import { Suspense, useLayoutEffect } from "react";

import { Loader, Stack } from "@braintrust/braintrust-ui-components";
import { useHideRequestLoader } from "@js/hooks/use-hide-request-loader";

import { CompleteProfileContentLazy } from "./lazy";

const bg = "#EDE3FA";

export const CompleteProfilePage = () => {
  useLayoutEffect(() => {
    document.body.style.setProperty("--page-bg", bg);
    return () => {
      document.body.style.removeProperty("--page-bg");
    };
  }, []);

  useHideRequestLoader();

  return (
    <Stack
      sx={{
        backgroundColor: bg,
        minHeight: "100vh",
      }}
    >
      <Suspense fallback={<Loader centered />}>
        <CompleteProfileContentLazy />
      </Suspense>
    </Stack>
  );
};
